// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.category_enum_d862d2fc */
var CategoryEnumD862d2fc;
(function (CategoryEnumD862d2fc) {
    CategoryEnumD862d2fc["Base"] = "Base";
    CategoryEnumD862d2fc["Methanol"] = "Methanol";
    CategoryEnumD862d2fc["Antifoam"] = "Antifoam";
    CategoryEnumD862d2fc["Acid"] = "Acid";
    CategoryEnumD862d2fc["Water"] = "Water";
    CategoryEnumD862d2fc["Trace solution"] = "Trace solution";
})(CategoryEnumD862d2fc || (CategoryEnumD862d2fc = {}));
;
export default CategoryEnumD862d2fc;
/** Zod schema for category_enum_d862d2fc */
export const categoryEnumD862d2fc = z.nativeEnum(CategoryEnumD862d2fc);
//# sourceMappingURL=CategoryEnumD862d2fc.js.map